import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import DashboardService from "core/components/home/dashboardService";
import {observer} from "mobx-react";
import {PageProps} from "core/metamodel/metaConstant";
import {Layout, Layouts, Responsive, WidthProvider} from 'react-grid-layout';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import styled from "styled-components";
import securityService from "core/security/securityService";
import {action, observable, ObservableMap, toJS} from "mobx";
import {screenLg, screenMd, screenSm, screenXs} from "core/common/config/variables";
import {formatId, parseId} from "core/common/utils/utils";
import DashboardSetupComponent from "core/components/home/dashboardSetupComponent";
import gridService from "core/grid/gridService";
import {GridLocation} from "core/grid/domain/grid";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";
import mdEntityService from "core/metamodel/mdEntityService";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const Main = styled.main`
  padding: 10px;
  height: 100%;
`;

const _addButtonStyle = {
  float: 'right',
  margin: 20
};

@observer
export default class Home extends PageAncestor<PageProps, undefined> {

  static title = 'Zauzoo Home';
  static icon = 'home';
  static rootPage = true;


  @observable layouts: Layouts;



  componentWillMount() {
    this.layouts = securityService.currentUser.layoutConfig;
    if (!this.layouts) {
      this.layouts = {lg: []};
    }
  }

  componentDidMount() {
    let gridLocations: string[] = this.layouts.lg.map(l => parseId(l.i)[0]);
    return gridService.fetchGrids(...gridLocations);
  }

  @action addGrid = (gridLocation: string, gridConfig: number) => {
    return gridService.fetchGrids(gridLocation)
      .then(action("addGrid-cb", (gridMap: ObservableMap<GridLocation>) => {
        this.layouts.lg.push({i: formatId(gridLocation, gridConfig), x: 0, y: 0, w: 6, h: 2});
      }));
  };



  render() {
    console.log("render Home",  this.layouts);

    const layouts = {lg: [
      {i: 'a', x: 0, y: 0, w: 1, h: 2, static: true},
      {i: 'b', x: 0, y: 0, w: 3, h: 2, minW: 2, maxW: 4},
      {i: 'c', x: 0, y: 0, w: 1, h: 2}
    ]};

    return (
      <Main>

        <ResponsiveReactGridLayout className="layout" layouts={toJS(this.layouts)}
                                   breakpoints={{lg: screenLg, md: screenMd, sm: screenSm, xs: screenXs, xxs: 0}}
                                   cols={{lg: 12, md: 10, sm: 6, xs: 4, xxs: 2}}>

          {
            this.layouts.lg.map( (layout: Layout) => {
              let strings = parseId(layout.i);
              let gridLocation = strings[0];
              let gridConfig = parseInt(strings[1]);
              let grid = gridService.getOrCreateGrid(gridLocation);
              grid.assignActiveGridConfig(grid.getActiveGridConfig(gridConfig));
              return (
                <GridComp key={layout.i} grid={grid} uiLocation={UILOCATION.dashboard} entities={mdEntityService.entityMap}  />
              );
            })
          }

          {/*

          <div key={"a"} style={{backgroundColor: 'red'}}>1</div>
          <div key={"b"} style={{backgroundColor: 'green'}}>2</div>
          <div key={"c"} style={{backgroundColor: 'blue'}}>3</div>

          */}
        </ResponsiveReactGridLayout>

        {/*
        <DashboardSetupComponent addGrid={this.addGrid}/>
        */}


      </Main>

    )
      ;
  }

}



// WEBPACK FOOTER //
// ./src/core/components/home/home.tsx